import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../repeat/Header";
import Footer from "../repeat/Footer";
import Collageview from "./collageview.mp4";
import "./home.css";
import cse from "./departments/Computer Departmet.jpg";
import ece from "./departments/ECE Department.jpg";
import eee from "./departments/EEE Department.jpg";
import mech from "./departments/Mech Department.jpg";
import general from "./departments/General Department1.jpg";
import library from "../images/library.jpeg";
import computer from "../images/computer lab.jpg";
import sports from "../images/sports1.png";
import ncc from "../images/ncc.png";
import hostal from "../images/hostal.jpg";
import Eyantra from "../images/E yantra lab.jpg";
import Virtual from "../images/Virtual Room.jpg";
import Digital from "../images/Digital Learning.jpg";
import SkillHub from "../images/Skill-Hub.jpg";
import vision from "../images/vision.png";

const Home = () => {
  const [news, setNews] = useState([]);
  const [showNews, setShowNews] = useState(true);
  const [currentSeats, setCurrentSeats] = useState({
    totalSeats: 0,
    totalBoys: 0,
    totalGirls: 0,
    totalStaff: 0,
  });

  const messages = [
    "Welcome to Dr YC James Yen Government Polytechnic, Kuppam.",
    "Affiliated to State Board of Technical Education and Training AP.",
    "Empowering Ethical and Skilled Engineers for a Sustainable Future.",
    "A Place to Learn, A Chance to Grow.",
    "Grow The Personal Skills In this College.",
  ];

  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);
  const navigate = useNavigate();

  // Message scrolling effect
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentMessageIndex((prevIndex) => (prevIndex + 1) % messages.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  // Animation function to count up values
  const animateValue = (start, end, elementId) => {
    const element = document.getElementById(elementId);
    if (!element) return; // Ensure the element exists before animation

    let current = start;
    const increment = end / 100; // Adjust animation speed
    const interval = setInterval(() => {
      current += increment;
      if (current >= end) {
        current = end;
        clearInterval(interval);
      }
      element.innerText = Math.round(current);
    }, 20);
  };

  // Fetch news data
  useEffect(() => {
    fetch("https://gptkpm.in/backend/home/home.php")
      .then((response) => response.json())
      .then((data) => setNews(data))
      .catch((error) => console.error("Error fetching news:", error));
  }, []);

  // Fetch hostel information
  useEffect(() => {
    fetch("https://gptkpm.in/backend/home/get_home_info.php")
      .then((response) => response.json())
      .then((data) => {
        if (!data.error) {
          setCurrentSeats({
            totalSeats: data.total || 0,
            totalBoys: data.totalBoys || 0,
            totalGirls: data.totalGirls || 0,
            totalStaff: data.staff || 0,
          });

          // Trigger animations after data is set
          animateValue(0, data.total || 0, "totalSeats");
          animateValue(0, data.totalBoys || 0, "totalBoys");
          animateValue(0, data.totalGirls || 0, "totalGirls");
          animateValue(0, data.staff || 0, "totalStaff");
        } else {
          console.error(data.error);
        }
      })
      .catch((error) => console.error("Error fetching data:", error));
  }, []);

  const handleNavigation = (path) => {
    navigate(path);
  };

  const toggleNews = () => {
    setShowNews(!showNews);
  };

  return (
    <div style={{ overflowX: "hidden" }} className="box9">
      <Header />
      <div className="video-container">
        <div className="scrollable-text">
          <p>{messages[currentMessageIndex]}</p>
        </div>
        <video src={Collageview} autoPlay muted loop className="video-element"></video>
      </div>
      <div className="box0">
        <div className="box1">
          <h1 className="welcome">Welcome to the gptkpm.in</h1>
        </div>
      </div>

      <section className="hostel-info-section">
        <div className="info-container">
          <div className="info-item">
            <h2>Total Strength</h2>
            <p id="totalSeats">0</p>
          </div>
          <div className="info-item">
            <h2>Total Boys</h2>
            <p id="totalBoys">0</p>
          </div>
          <div className="info-item">
            <h2>Total Girls</h2>
            <p id="totalGirls">0</p>
          </div>
          <div className="info-item">
            <h2>Total Staff</h2>
            <p id="totalStaff">0</p>
          </div>
        </div>
      </section>
      <div id="part-1">
        <h2>Educate. Empower. Excel.</h2>
        <p>
          Educate. Empower. Excel. is a powerful mantra that encourages continuous learning, personal growth, and the pursuit of excellence.
        </p>
      </div>

      <div id="part-22">
        <h2 className="toggle-header">
          Latest Updates and Information for College Students Click to open
        </h2>
        {showNews && (
          <div className="news-container">
            {news.length > 0 ? (
              <div className="news-wrapper">
                <ul className="news-list">
                  {news.map((item, index) => (
                    <li key={index} className="news-item">
                      <a href={item.url} target="_blank" rel="noopener noreferrer">
                        {item.title}
                      </a>
                      <p>{new Date(item.date).toLocaleDateString()}</p>
                    </li>
                  ))}
                </ul>
              </div>
            ) : (
              <p>No news available at the moment.</p>
            )}
          </div>
        )}
      </div>
      <div id="part-3">
        <h2>Empowering Ethical and Skilled Engineers for a Sustainable Future</h2>
        <p>
          Preparing students with the technical skills, ethical values, and responsibility to create solutions that positively impact society and the environment.
        </p>
      </div>

      <div id="part-4">
        <img src={vision} alt="Vision" />
        <div className="part-right">
          <div className="vision">
            <h2>Vision:</h2>
            <p>
              To emanate as a leading institution in education to develop engineering professionals who are technically competent, ethical, and environmentally friendly.
            </p>
          </div>
          <div className="vision">
            <h2 style={{ color: "#0070c0" }}>Mission:</h2>
            <p>
              To develop competent engineering professionals through high-quality academic instructions and industry collaborations to face emerging challenges.
            </p>
          </div>
        </div>
      </div>
      <div id="part-5">
        <div id="part-5-left">
          <h2>Departments</h2>
          <p>Here is a list of all the departments in the college</p>
        </div>
        <div id="part-5-right" className="horizontal-scroll-container">
          <div className="img-dept">
            <img src={cse} alt="DCME Department" />
            <button onClick={() => handleNavigation("/cse")}>DCME</button>
          </div>
          <div className="img-dept">
            <img src={ece} alt="DECE Department" />
            <button onClick={() => handleNavigation("/Ece")}>DECE</button>
          </div>
          <div className="img-dept">
            <img src={eee} alt="DEEE Department" />
            <button onClick={() => handleNavigation("/Eee")}>DEEE</button>
          </div>
          <div className="img-dept">
            <img src={mech} alt="DME Department" />
            <button onClick={() => handleNavigation("/Mech")}>DME</button>
          </div>
          <div className="img-dept">
            <img src={general} alt="General Department" />
            <button onClick={() => handleNavigation("/General")}>General</button>
          </div>
        </div>
      </div>


      <div className="facilities">
        <h1>Facilities</h1>
        <p>Here is a list of all the facilities in the college</p>
        <div className="facilities-grid horizontal-scroll-container">
          <div className="facility-card">
            <img src={library} alt="Library" />
            <div className="facility-title">Library</div>
          </div>
          {/* <div className="facility-card">
            <img src={computer} alt="Computer Labs" />
            <div className="facility-title">Computer Labs</div>
          </div> */}
          <div className="facility-card">
            <img src={sports} alt="Sports" />
            <div className="facility-title">Sports</div>
          </div>
          <div className="facility-card">
            <img src={ncc} alt="NCC" />
            <div className="facility-title">NCC</div>
          </div>
          <div className="facility-card">
            <img src={hostal} alt="Hostel" />
            <div className="facility-title">Hostel</div>
          </div>
          <div className="facility-card">
            <img src={Digital} alt="Hostel" />
            <div className="facility-title">Digital Learning</div>
          </div>
          <div className="facility-card">
            <img src={Virtual} alt="Hostel" />
            <div className="facility-title">Virtual Room</div>
          </div>
          <div className="facility-card">
            <img src={Eyantra} alt="Hostel" />
            <div className="facility-title">E yantra lab</div>
          </div>
          <div className="facility-card">
            <img src={SkillHub} alt="Hostel" />
            <div className="facility-title">Skill-Hub</div>
          </div>
        </div>
      </div>


      <div className="campus-connect">
        <h1>Campus Connect</h1>
        <p className="description">
          Streamlining college administration with efficient, real-time management for students and staff.
        </p>
        <p className="sub-description">
          A dynamic platform for managing and uploading college events, with seamless image uploads and real-time updates.
        </p>
        <button className="action-button">VIEW ON EVENTS</button>
      </div>

      <Footer />
    </div>
  );
};

export default Home;
